import React from "react";
import { Link } from "react-router-dom";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import { mostrarMes, ICONOS_CDR } from "../../../utils/Tools";
import get from "../../../utils/get";

const HotelCuadro = (props) => {
  const { producto = {} } = props;
  /*
  const shareClick = (e) => {
    e.preventDefault();
    return;
  };
  */
  const path = `/hoteles/listado-de-hoteles/${producto.codigoProvincia}/${producto.fechaIn}/${producto.fechaOut}/2`;

  const imagen = {
    backgroundImage:
      "url(../assets/img/resultados/" + producto.imagen + ")",
  };

  const servicios = get(producto, 'hotel.detalles', []);
  //FC: antes del refactor de la tabla nueva
  //const precioPaquete = Math.round(((this.props.producto.tarifas[0].tarifaNeta - (this.props.producto.charters[0].tarifa.tarifaNeta * (this.props.producto.charters[0].promoValijaYa / 100))) * this.props.producto.moneda.cotizacion)).toLocaleString();
  //FC: despues del refactor
  ///hoteles/listado-de-hoteles/:destino?/:fechaIn?/:fechaOut?/:pasajeros?
  return (
    <div className="destino">
      <Link to={path}>
        {/*--INFO SOBRE FOTO--*/}
        <div className="bg" style={imagen}>
          {/*--ESTADIA--*/}
          <div className="estadia" style={{backgroundColor: 'rgba(58, 58, 58, 0.7)'}}>
            <div className="icon-container">
              <i className="material-icons">bed</i>
            </div>
            <p>{producto.destino}</p>
          </div>
          {/*--FEATURES--*/}
          <div className="features">
          <ul>
            {
              servicios.map((serv, i) => {
                return <li key={i}><i className="material-icons" title={serv.nombre}>{ICONOS_CDR[serv.nombre]}</i></li>
              })
            }
            { producto.regimenes.map((reg, i) => {
              if (reg.denominacion === 'SIN REGIMEN') return null;
              return <li key={i}><i className="material-icons" title={reg.denominacion}>{ICONOS_CDR[reg.denominacion] || 'restaurant'}</i></li>
            })
            }
          </ul>

        </div>
        </div>
        {/*--INFO DEBAJO DE FOTO--*/}
        <div className="info">
          <h3>{producto.nombre}</h3>
          <h5>{mostrarMes(producto.fechaIn)} {producto.fechaIn.split('-')[0]}</h5> 
          <h2>$ {Math.round(producto.tarifa)}</h2>
          <p>Habitación Doble por Noche</p>
          <p>+ tasas e impuestos</p>
          <div className="redesSociales btn-group dropup">
            <button
              className="btn btn-default btn-xs "
              type="button"
              data-toggle="dropdown"
            >
              <i className="material-icons">share</i>
            </button>
            <ul className="dropdown-menu">
              <li>
                <FacebookShareButton
                  hashtag="#PedrazaViajes"
                  quote={producto.nombre}
                  url={`https://pedraza.com.ar${path}`}
                  className=""
                >
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
              </li>
              <li>
                <TwitterShareButton
                  hashtag="#PedrazaViajes"
                  url={`https://pedraza.com.ar${path}`}
                  title={`Pedraza Viajes y Turismo ${producto.nombre}`}
                  className=""
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
              </li>
              <li>
                <WhatsappShareButton
                  url={`https://pedraza.com.ar${path}`}
                  title="Paquete De Pedraza Viajes y Turismo"
                  separator=" "
                  className=""
                >
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>
              </li>
            </ul>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default HotelCuadro;



// WEBPACK FOOTER //
// ./src/components/Hoteles/Home/HotelCuadro.js